import React from 'react';
import { siteConfig } from '../mock/data';
import { trackClick } from '../lib/tracking';
import { useSettings } from '../context/SettingsContext';
import { ShopeeIcon, TikTokShopIcon, WhatsAppIcon } from './BrandIcons';

const SHOPEE_STORE = 'https://s.shopee.co.id/5q6tiI4qUQ?share_channel_code=1';
const TIKTOK_STORE = 'https://vt.tiktok.com/ZSXEwx62Q/?page=Mall';

function resolveStoreUrl(value, fallback) {
  if (!value || value === '#' || String(value).includes('tokopedia.com') || String(value).includes('japo')) {
    return fallback;
  }
  return value;
}

export default function ProductCard({ product }) {
  const { settings } = useSettings();
  const phone = settings.whatsapp_number || siteConfig.whatsappNumber;
  const waLink = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(`Halo Kak! Saya tertarik dengan produk ${product.name}. Boleh minta info harga dan minimum order-nya?`)}`;
  const shopeeUrl = resolveStoreUrl(product.shopee || settings.shopee, SHOPEE_STORE);
  const tiktokUrl = resolveStoreUrl(product.tokopedia || settings.tokopedia, TIKTOK_STORE);

  return (
    <div className="group bg-white rounded-2xl overflow-hidden card-shadow border border-gray-100">
      <div className="relative aspect-square overflow-hidden bg-gray-50">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 bg-japo-yellow text-gray-900 text-[10px] font-extrabold px-2.5 py-1 rounded-full uppercase tracking-wide">
          Premium
        </div>
      </div>
      <div className="p-5">
        <div className="text-xs text-gray-500 mb-1 font-medium">{product.packaging}</div>
        <h3 className="font-bold text-lg text-gray-900 mb-4 group-hover:text-japo-green transition-colors">
          {product.name}
        </h3>
        <div className="grid grid-cols-3 gap-2">
          <a
            href={shopeeUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick('marketplace_shopee', { product: product.name })}
            className="flex items-center justify-center py-2 px-1 rounded-lg bg-orange-50 hover:bg-orange-100 transition-colors border border-orange-100"
            title="Toko Shopee BelBel"
            aria-label="Toko Shopee BelBel"
          >
            <ShopeeIcon className="w-full h-9" />
          </a>
          <a
            href={tiktokUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick('marketplace_tiktok', { product: product.name })}
            className="flex items-center justify-center py-2 px-1 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors border border-gray-200"
            title="Toko TikTok Shop Belbel"
            aria-label="Toko TikTok Shop Belbel"
          >
            <TikTokShopIcon className="w-full h-9" />
          </a>
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick('whatsapp_product', { product: product.name })}
            className="flex items-center justify-center py-2 px-1 rounded-lg bg-[#25D366]/10 hover:bg-[#25D366]/20 transition-colors border border-[#25D366]/20 text-[#128C7E]"
            title="Chat WhatsApp"
            aria-label="Chat WhatsApp"
          >
            <WhatsAppIcon className="w-full h-9" />
          </a>
        </div>
      </div>
    </div>
  );
}
